import { Layout } from "antd";

import { Menu } from "antd";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBroker } from "../../context/BrokerContext";
import { filterNavigationByProfile } from "../../utils/profileAccess";
import LogoComponent from "../Logo";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { Sider, Content } from "./styles";

type IPageWrapperProps = {
  header?: boolean;
  sideBar?: boolean;
  overflow?: boolean;
  page?: string;
  children?: ReactNode;
};

function menuSelectionFromPath(pathname: string): string[] {
  const first =
    pathname.replace(/^\//, "").split("/").filter(Boolean)[0] ?? "weighingRail";
  if (first === "logoff") return ["sair"];
  return [first];
}

const PageWrapper: React.FC<IPageWrapperProps> = ({
  children,
  sideBar,
  header,
}) => {
  const { currentBroker } = useBroker();
  const { authenticated, user } = useAuth();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  const [brokenLayout, setBrokenLayout] = useState(false);
  const [menuOpenKeys, setMenuOpenKeys] = useState<string[]>([]);

  const selectedMenuKeys = useMemo(
    () => menuSelectionFromPath(location.pathname),
    [location.pathname]
  );

  const menuItems = useMemo(
    () => filterNavigationByProfile(currentBroker.navigationMenu, user?.profile),
    [currentBroker.navigationMenu, user?.profile]
  );

  useEffect(() => {
    if (
      location.pathname.startsWith("/acessos") ||
      location.pathname.startsWith("/perfis")
    ) {
      setMenuOpenKeys((prev) =>
        prev.includes("configuracoes") ? prev : [...prev, "configuracoes"]
      );
    }
  }, [location.pathname]);

  useEffect(() => {
    if (brokenLayout) {
      setCollapsed(true);
    }
  }, [location.pathname, brokenLayout]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {sideBar && (
        <Sider
          breakpoint="lg"
          collapsedWidth={brokenLayout ? 0 : 80}
          collapsible={!brokenLayout}
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            setBrokenLayout(broken);
            setCollapsed(broken);
          }}
          onCollapse={(value: any) => setCollapsed(value)}
        >
          <LogoComponent />
          {authenticated && (
            <Menu
              theme={"dark"}
              mode={"inline"}
              items={menuItems}
              selectedKeys={selectedMenuKeys}
              openKeys={menuOpenKeys}
              onOpenChange={setMenuOpenKeys}
            />
          )}
        </Sider>
      )}

      <Layout>
        {header && (
          <Header
            showMenuToggle={sideBar && brokenLayout}
            onToggleSidebar={() => setCollapsed((prev) => !prev)}
          />
        )}
        <Content>{children}</Content>

        <Footer
          versionMajor={currentBroker.versionControl.major}
          versionMinor={currentBroker.versionControl.minor}
          versionPatch={currentBroker.versionControl.patch}
        />
      </Layout>
    </Layout>
  );
};

export default PageWrapper;
